import React from "react";
import './select.css'
import { color } from "../../utils/themes/color";
import { Select } from 'antd';



export default function SELECT(props) {

    return (
        <Select
            className="m-select"
            onChange={(e) => props.click(e)}
            value={props.value != undefined ? props.value : null}
            placeholder={props.placeholder != undefined ? props.placeholder : ""}
            style={{ color: color.primary }}>
            {
                props.items != null && props.items.lenght != 0 ?
                    props.items.map((itm, idx) => {
                        return <option key={idx} value={itm.value}>{itm.name}</option>
                    })
                    : null
            }
        </Select>
    )
}